<template>
  <div>
    <h2>{{ titulo == '' ? 'Tabla de ejemplo' : titulo}}</h2>
    <table v-if="objeto != null" style="width:100%" class="table nowrap table-bordered">
      <thead>
        <tr>
          <th>Pregunta</th>
          <th>Opcion</th>
          <th>Cantidad</th>
        </tr>
      </thead>
      <tbody v-for="(categoria, iteracion) in objeto.categoria" :key="categoria.id">
        <template v-for="(value, key, index) in objeto.data">
          <tr :key=index v-if="key==0">
            <td :rowspan="objeto.data.length">{{categoria}}</td>
            <td>{{value.name}}</td>
            <td>{{value.data[iteracion]}}</td>
          </tr>
          <tr :key=index v-else>
            <td>{{value.name}}</td>
            <td>{{value.data[iteracion]}}</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name:'TablaReporte',
  props:['objeto', 'titulo'],
  data(){
    return {
      loading: true,
    }
  },
}
</script>

<style scoped>
</style>
